
import { Middleware } from 'redux';
import { CHANGE_LANGUAGE } from "../actions/languageActionTypes";
import { StoreState } from 'src/Store';
import {  UATConstants, updateUATConstants } from 'src/Common/Models/UATConstants';
import translationENUS from 'src/Locales/en-US.json'; 
import translationENUK from 'src/Locales/en-UK.json';
import translationJA from 'src/Locales/ja.json'; 
import { applyI18n } from 'src/Locales/i18n';





const languageMiddleware: Middleware<{}, StoreState> = store => next => action => {
    if (action.type === CHANGE_LANGUAGE) {
        const newLanguage = action.payload.newLanguage;
        var json = require(`src/Locales/${newLanguage}.json`); 

            const constants: UATConstants = require('src/Common/Models/UATConstants.ts');

            const updatedConstants = applyI18n(constants, newLanguage);
            store.dispatch({ type: 'UPDATE_TRANSLATIONS', payload: updatedConstants });

    }
    return next(action);
};

export default languageMiddleware;
